import api from 'api';

interface RecoverTasksResult {
  recovered_count: number;
  task_ids?: string[];
}

export default function bulkResetTasks(
  projectId: string,
  workflowId: string,
  taskIds: string[],
): Promise<RecoverTasksResult> {
  return api
    .post(`projects/${projectId}/workflows/${workflowId}/tasks/bulk-reset`, {
      json: { task_ids: taskIds },
    })
    .json();
}
